import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

// Entra SSO config is injected at build time (see deploy-fe-*.sh). When either
// var is unset — local dev, or before IT provisions the app registration — SSO
// is disabled: the Microsoft button is hidden and password login is unaffected.
const TENANT_ID = import.meta.env['VITE_ENTRA_TENANT_ID'] as string | undefined;
const CLIENT_ID = import.meta.env['VITE_ENTRA_CLIENT_ID'] as string | undefined;

export const ssoEnabled = Boolean(TENANT_ID && CLIENT_ID);

// Auth Code + PKCE, ID-token only (TRD §7.3). The backend validates the ID
// token; we never request access tokens or call Graph on the user's behalf.
export const loginRequest = { scopes: ['openid', 'profile', 'email'] };

let initPromise: Promise<PublicClientApplication> | null = null;

/** Lazily build + initialize the MSAL instance (MSAL v3+ requires initialize()). */
export function getMsalInstance(): Promise<PublicClientApplication> {
  if (!ssoEnabled) {
    return Promise.reject(new Error('Entra SSO is not configured'));
  }
  if (initPromise === null) {
    const config: Configuration = {
      auth: {
        clientId: CLIENT_ID as string,
        authority: `https://login.microsoftonline.com/${TENANT_ID}`,
        // Must exactly match the redirect URI registered with IT.
        redirectUri: `${window.location.origin}/admin/auth/callback`,
        postLogoutRedirectUri: `${window.location.origin}/admin/login`,
      },
      cache: { cacheLocation: 'sessionStorage' },
    };
    const app = new PublicClientApplication(config);
    initPromise = app.initialize().then(() => app);
  }
  return initPromise;
}
